module.exports = __webpack_public_path__ + "img/electronic_electric_enabled_selected.00141253.svg";